export default "# Modifiers\n\n![Abrupt](abrupt.doc)\n![Hide](hide.doc)\n![Reflect](reflect.doc)\n![Rounded](rounded.doc)\n![Smooth](smooth.doc)\n";